const Const = {
    SHOP_PROPERTIES_GET_SUBSHOPS_REQUEST: 'SHOP_PROPERTIES_GET_SUBSHOPS_REQUEST',
    SHOP_PROPERTIES_GET_PROPERTIES_REQUEST: 'SHOP_PROPERTIES_GET_PROPERTIES_REQUEST',
    SHOP_PROPERTIES_GET_PROPERTIES_REQUEST_START: 'SHOP_PROPERTIES_GET_PROPERTIES_REQUEST_START',
    GET_RETURN_REASONS_REQUEST: 'GET_RETURN_REASONS_REQUEST'
};

export default Const;